import { getDistance } from 'geolib';

export function isWithinRadius(
    current: { latitude: number; longitude: number },
    target: { latitude: number; longitude: number },
    radiusInMeters = 500
): boolean {
    const distance = getDistance(current, target);
    return distance <= radiusInMeters;
}